import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const problems = ['Recetas de internet que nunca te quedan igual que en el video', 'Gastás en ingredientes y tirás la mitad porque la masa no levantó', 'Los glaseados te salen feos y no sabés qué estás haciendo mal', 'Cobrás cualquier cosa porque no tenés una fórmula de precios', 'El packaging te da vergüenza y no podés mostrar el producto en Instagram', 'Querés emprender pero arrancás y parás, arrancás y parás', 'La semana termina igual que empezó — sin ningún peso extra en el bolsillo'];
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-132">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-134">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-4 md:mb-8 leading-tight" data-id="element-135">
            ¿Cuántos domingos más vas a pasar mirando videos de minidonas sin
            animarte a empezar?
          </h2>

          <div className="text-center mb-6 md:mb-10 space-y-2 md:space-y-4" data-id="element-136">
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-137">
              Querés tener tu propio negocio. Algo tuyo. Algo que podés hacer
              desde casa, a tu ritmo, con tus propias manos. Pero cada vez que
              intentás arrancar, aparece lo mismo:
              <br data-id="element-138" />
              <br data-id="element-139" />
              La masa no te queda. Los glaseados se corren o quedan opacos. No
              sabés cuánto cobrar. Y terminás pensando que "capaz no es para
              vos".
            </p>
            <p className="text-xl md:text-2xl font-bold text-orange-500" data-id="element-140">
              No es falta de talento. Es falta de un sistema.
            </p>
          </div>

          <div className="mb-6 md:mb-10" data-id="element-141">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 md:mb-6 text-center" data-id="element-142">
              ❌ Lo que pasa sin el Mega Pack:
            </h3>
            <div className="bg-orange-50 border border-red-200 rounded-lg overflow-hidden" data-id="element-143">
              <div className="divide-y divide-red-100" data-id="element-144">
                {problems.map((problem, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-4 p-4" data-id="element-145">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-146" />
                    <p className="text-gray-600" data-id="element-147">{problem}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-orange-500 text-center" data-id="element-148">
            ¿Y si esta fuera la última semana que pasó así?
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}